import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Wrench } from 'lucide-react';

export const Route = createFileRoute('/admin-console/advanced')({
    staticData: {
        permissions: ['admin_system:read'],
        breadcrumb: {
            title: 'Advanced',
            inactive: true,
        },
        ui: {
            icon: Wrench,
            title: 'Advanced',
            menuDescription: 'Advanced system configuration',
        },
    },
    component: Outlet,
});
